module.exports = __webpack_public_path__ + "static/img/preview-1.21bbf57.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/preview/zombs/preview-1.png
// module id = Wxj1
// module chunks = 35